import LocalizedStrings from "react-localization";
import headerStrings from "./HeaderStrings.js";
import footerStrings from "./FooterStrings.js";
import homePageStrings from "./HomePageStrings.js";
import loginStrings from "./LoginStrings.js";
import playerInfoStrings from "./PlayerInfoStrings.js";
import studioInfoStrings from "./StudioInfoStrings.js";
import libraryStrings from "./LibraryPageStrings.js";

let webContentStrings = new LocalizedStrings({
    en: {
        headerStrings: headerStrings,
        footerStrings: footerStrings,
        homePageStrings: homePageStrings,
        loginStrings: loginStrings,
        playerInfoStrings: playerInfoStrings,
        studioInfoStrings: studioInfoStrings,
        libraryStrings: libraryStrings,
    },
});

export default webContentStrings;